import { CEP_Config } from 'vite-cep-plugin';

import { version } from './package.json';
import { CURRENT_ENV } from './src/js/utils/currentEnv.utils';

const config: CEP_Config = {
  version,
  id:
    CURRENT_ENV === 'development' || process.env.FOR_DEV
      ? 'fr.toolpad.autoCutV3.dev'
      : 'fr.toolpad.autoCut',
  displayName: !process.env.FOR_DEV
    ? 'AutoCut - V3 - PROD'
    : 'AutoCut - V3 - DEV',
  symlink: 'local',
  port: 3001,
  servePort: 5000,
  startingDebugPort: 8088,
  extensionManifestVersion: 11.0,
  requiredRuntimeVersion: 11.0,
  hosts: [{ name: 'PPRO', version: '[0.0,99.9]' }],
  type: 'Panel',
  iconDarkNormal: './src/assets/light-icon.png',
  iconNormal: './src/assets/dark-icon.png',
  iconDarkNormalRollOver: './src/assets/light-icon.png',
  iconNormalRollOver: './src/assets/dark-icon.png',
  parameters: ['--v=0', '--enable-nodejs', '--mixed-context'],
  width: 500,
  height: 550,

  panels: [
    {
      mainPath: './index.html',
      name: 'main',
      panelDisplayName: 'AutoCut - V3 - DEV',
      autoVisible: true,
      width: 600,
      height: 650,
    },
  ],
  build: {
    jsxBin: 'off',
    sourceMap: true,
  },
  zxp: {
    country: 'US',
    province: 'CA',
    org: 'MyCompany',
    password: 'mypassword',
    tsa: 'http://timestamp.digicert.com/',
    sourceMap: false,
    jsxBin: 'off',
  },
  installModules: [],
  copyAssets: [],
  copyZipAssets: [],
};
export default config;
